import { render, staticRenderFns } from "./AgentDetails.vue?vue&type=template&id=156fdb0f&scoped=true"
import script from "./AgentDetails.vue?vue&type=script&lang=ts"
export * from "./AgentDetails.vue?vue&type=script&lang=ts"
import style0 from "./AgentDetails.vue?vue&type=style&index=0&id=156fdb0f&lang=scss"
import style1 from "./AgentDetails.vue?vue&type=style&index=1&id=156fdb0f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156fdb0f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/Cona-OSUM/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('156fdb0f')) {
      api.createRecord('156fdb0f', component.options)
    } else {
      api.reload('156fdb0f', component.options)
    }
    module.hot.accept("./AgentDetails.vue?vue&type=template&id=156fdb0f&scoped=true", function () {
      api.rerender('156fdb0f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/agents/components/AgentDetails.vue"
export default component.exports